import { render, staticRenderFns } from "./ProductsFromList.vue?vue&type=template&id=2a34826a&"
import script from "./ProductsFromList.vue?vue&type=script&lang=js&"
export * from "./ProductsFromList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFromList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports